import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { ViewV1 } from './v1/ViewV1';
import { ViewV2 } from './v2/ViewV2';

export const SignupSubmitted: React.FC<any> = () => {
    const { isV2VerificationEnabled, enabledFeaturesLoading } = useSelector(
        (state: AppState) => ({
            userEmail: state.Signup.userEmail,
            isV2VerificationEnabled:
                state.FeatureFlagging.features[Features.VERIFICATION_UI],
            enabledFeaturesLoading: state.FeatureFlagging.isLoading,
        }),
    );

    if (enabledFeaturesLoading) {
        return null;
    }

    return isV2VerificationEnabled ? <ViewV2 /> : <ViewV1 />;
};
